/**
 * @fileoverview Default ENGLISH strings for `@puffin-core/captcha-ui`.
 * @package @puffin-core/captcha-ui
 *
 * AAS-I18N-002 W8 / user ruling 25 (2026-08-10).
 *
 * Before this bundle existed `<CaptchaField>` carried four hardcoded English
 * literals — three `aria-label`s and one visible error sentence — and it renders
 * on the **first screen of all ten apps** plus every password-reset modal, signup
 * form and public contact form. `web/no-hardcoded-strings` scores every one of
 * them **0** and always will: the census walks `apps/**`, and these live in
 * `packages/**`. RECIPE miss-class 9.
 *
 * The DEV-bypass marker and sentence (`captcha.dev.*`) joined this bundle with
 * PACKAGE-I18N-SEAT (JSDOC-PROP-CONTRACT-001, push 17). They had been left out on
 * the reasoning that a developer diagnostic is easier to search for in English.
 * The owner's ruling for the package seat ("Burn to zero, then switch on") exempts
 * four categories, and a developer-only screen is not one of them;
 * `@puffin-core/debugging` already translates its whole dev overlay. The
 * environment variable's NAME stays literal inside the sentence, in every
 * language, so a search for it still finds the screen.
 */

export const DEFAULT_CAPTCHA_STRINGS = Object.freeze({
  /* Accessible group names — assistive tech only, never visible */
  'captcha.ariaLabel': 'Security verification',
  'captcha.ariaLabelDev': 'Security verification (development mode)',
  'captcha.unavailable.ariaLabel': 'Security verification unavailable',

  /* The one VISIBLE sentence: production build with no site key configured */
  'captcha.unavailable.message': 'Security verification unavailable. Please contact support.',

  /* The DEV-bypass marker and sentence: a developer's machine with no site key */
  'captcha.dev.badge': 'DEV',
  'captcha.dev.bypassed': 'CAPTCHA bypassed - Set VITE_TURNSTILE_SITE_KEY to enable',
});

export default DEFAULT_CAPTCHA_STRINGS;
